import { render, staticRenderFns } from "./ProposedPayPlanDrawerConnected.vue?vue&type=template&id=7134e0bc&scoped=true"
import script from "./ProposedPayPlanDrawerConnected.vue?vue&type=script&setup=true&lang=js"
export * from "./ProposedPayPlanDrawerConnected.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProposedPayPlanDrawerConnected.vue?vue&type=style&index=0&id=7134e0bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7134e0bc",
  null
  
)

export default component.exports